/**
 * Boot decision seam (issue #943).
 *
 * Decides what to render at boot: the full app when WebAssembly is available, or
 * a friendly unsupported-environment screen when it is not (iOS Lockdown Mode,
 * codegen-blocking enterprise browsers). Extracted from index.tsx so it can be
 * unit-tested against the shipped code path.
 *
 * The capability check runs in the BODY (after imports are evaluated). This is
 * sufficient because the crypto module is import-safe (see crypto.ts: it only
 * fires wasm init when WebAssembly is available, and catches any failure), so no
 * synchronous crypto crash can occur before this decision is made.
 */
import type { ReactElement } from "react";
import App from "./App";
import UnsupportedBrowserScreen from "./components/shared/UnsupportedBrowserScreen";
import { isWebAssemblyAvailable } from "./lib/crypto/wasmSupport";

export function decideBootElement(): ReactElement {
  if (!isWebAssemblyAvailable()) {
    return <UnsupportedBrowserScreen />;
  }
  return <App />;
}
